import { WarningFilled } from '@ant-design/icons'
import { Modal } from 'antd'
import React from 'react'
import { COLORS } from '../../../../../constants/Colors'

interface Props {
  visible: boolean
  onToggleActive: () => void
  onClose: () => void
  isActive: boolean
}

interface State {
  toggleActivity: boolean
}

export class VariantWarningModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      toggleActivity: false,
    }
  }

  afterClose = () => {
    if (this.state.toggleActivity) {
      this.props.onToggleActive()
      this.setState({ toggleActivity: false })
    }
  }

  render() {
    return (
      <Modal
        title={`Make variant ${this.props.isActive ? 'inactive' : 'active'}`}
        visible={this.props.visible}
        okText={<div>Make {this.props.isActive ? 'inactive' : 'active'}</div>}
        width={600}
        okType={'danger'}
        onOk={() => {
          this.setState({ toggleActivity: true })
          this.props.onClose()
        }}
        onCancel={this.props.onClose}
        afterClose={this.afterClose}
      >
        <div className='d-flex'>
          <WarningFilled className='mr-3' style={{ fontSize: '48px', color: COLORS.red300 }} />
          <div className='d-block'>
            <div style={{ fontSize: '16px' }}>Warning</div>
            <div>
              Please note, this action will make this variant{' '}
              {this.props.isActive ? 'INACTIVE' : 'ACTIVE'} in ALL locations.
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}
